import { client as generatedClient } from '../generated/client/client.gen';
import type { AppParams } from '../types';

/**
 * Configure the auto-generated API client with base URL and auth.
 *
 * In dev we point at the stub server (no auth needed).
 * In prod we use the env-injected `VITE_API_URL` / `VITE_API_TOKEN`,
 * or the per-mount overrides from `AppParams.apiUrl` / `AppParams.apitoken`
 * passed by the integrator.
 */
export function configureApiClient(params: AppParams): void {
  const baseUrl =
    params.apiUrl ?? import.meta.env.VITE_API_URL ?? 'http://localhost:3030';
  const token = params.apitoken ?? import.meta.env.VITE_API_TOKEN ?? '';

  generatedClient.setConfig({
    baseUrl,
    headers: {
      'X-API-KEY': token,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export const apiClient = generatedClient;

/**
 * Resolved API config used by handcrafted (non-codegen) calls, e.g.
 * endpoints that return text/plain instead of JSON.
 */
export function resolveApiConfig(params: AppParams) {
  const baseUrl =
    params.apiUrl ?? import.meta.env.VITE_API_URL ?? 'http://localhost:3030';
  const token = params.apitoken ?? import.meta.env.VITE_API_TOKEN ?? '';
  return { baseUrl, token };
}

/**
 * Build an absolute URL for assets the backend returns as a relative path
 * (e.g. /storage/activity/.../foo.mp3). The file host is configured via
 * VITE_FILE_HOST or AppParams.fileHost; we fall back to the API host if
 * the integrator hasn't set one.
 */
export function getFileUrl(path: string | null | undefined, params: AppParams | null): string {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const fileHost =
    params?.fileHost ??
    import.meta.env.VITE_FILE_HOST ??
    params?.apiUrl ??
    import.meta.env.VITE_API_URL ??
    '';
  return `${fileHost}${path.startsWith('/') ? '' : '/'}${path}`;
}
